// extracted by mini-css-extract-plugin
export default {"card":"MeetingCard_card__b37JH","header":"MeetingCard_header__2kPY1"};